export { ChartBar as default } from './ChartBar';
